export const IMAGE_EDITING_FEATURES = {
	REMOVE_BACKGROUND: "removeBackground",
	BLUR_BACKGROUND: "blurBackground",
	EXPAND_BACKGROUND: "expandBackground",
	GENERATE_BACKGROUND_BY_TEXT: "generateBackgroundByText",
	GENERATE_BACKGROUND_BY_IMAGE: "generateBackgroundByImage",
	SOLID_BACKGROUND: "solidBackground",
	FOREGROUND_PLACEMENT: "foregroundPlacement",
	ERASE_OBJECT: "eraseObject",
	GENERATIVE_FILL: "generativeFill",
	CHANGE_ASPECT_RATIO: "changeAspectRatio",
	MEDIUM_DESTINATION: "mediumDestination",
	INCREASE_RESOLUTION: "increaseResolution",
	CUSTOM_SIZE: "customSize",
	IMAGE_EDITING: "imageEditing",
	BULK_IMAGE_EDITING: "bulkImageEditing",
	CROP_IMAGE: "cropImage",
} as const;

export type ImageEditingFeature = (typeof IMAGE_EDITING_FEATURES)[keyof typeof IMAGE_EDITING_FEATURES];

export const imageGenerationRoutes = [
	"prompt_enhancer",
	"text-to-vector/base/32",
	"text-to-vector/base/23",
	"text-to-vector/fast/23",
	"text-to-image/base/32",
	"text-to-image/base/22",
	"text-to-image/base/23",
	"text-to-image/fast/22",
	"text-to-image/fast/23",
	"text-to-image/hd",
	"reimagine",
	"refine_faces",
	"restyle_portrait",
];

export const imageEditingRoutes = [
	"erase_foreground",
	"eraser",
	"background/remove",
	"background/blur",
	"replace_bg",
	"image_expansion",
	"increase_resolution",
	"crop",
	"face",
	"gen_fill",
	"enhance_image",
	"objects/remove",
];

export const videoEditingRoutes = ["video/background/remove", "video/edit/increase_resolution"];

export const productGenRoutes = [
	"product_placement",
	"product/cutout",
	"product/packshot",
	"product/shadow",
	"product/lifestyle_shot_by_text",
	"product/lifestyle_shot_by_image",
];

export const tailoredGenRoutes = ["text-to-image/tailored", "text-to-vector/tailored"];

export const adGenerationRoutes = ["campaign_generator"];

export const otherRoutes = ["style", "image_to_psd"];

export type RouteGroupKey =
	| "image_generation"
	| "video_editing"
	| "image_editing"
	| "product_shot_editing"
	| "tailored_generation"
	| "ads_generation"
	| "others";

export const productGroupRouteMap: Record<RouteGroupKey, string[]> = {
	image_generation: imageGenerationRoutes,
	image_editing: imageEditingRoutes,
	video_editing: videoEditingRoutes,
	product_shot_editing: productGenRoutes,
	tailored_generation: tailoredGenRoutes,
	ads_generation: adGenerationRoutes,
	others: otherRoutes,
};

export const routeToGroup: Record<string, string> = (() => {
	const map: Record<string, string> = {};
	Object.entries(productGroupRouteMap).forEach(([group, routes]) => {
		routes.forEach((route) => {
			map[route] = group;
		});
	});
	return map;
})();
